/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS } from "@tCentro/theme/design";

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

export interface CENCategoryNameAndAdditionalDescriptionStyles {
    wrapper?: InjectableCss;
    categoryName?: TypographyProps;
    categoryAdditionalDescription?: TypographyProps;
}

export const CENcategoryNameAndAdditionalDescriptionStyles: CENCategoryNameAndAdditionalDescriptionStyles = {
    wrapper: {
        css: css`
            text-align: center;
        `,
    },
    categoryName: {
        variant: "h2",
        transform: "inherit",
        color: COLORS.black,
        css: css`
            margin-bottom: 32px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-bottom: 24px;
                            font-size: 24px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    categoryAdditionalDescription: {
        variant: "p",
        transform: "inherit",
        color: COLORS.black,
        css: css`
            width: 60%;
            margin: 0 auto !important;
            margin-bottom: 34px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100% !important;
                            margin-bottom: 20px !important;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
};

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

const styles = CENcategoryNameAndAdditionalDescriptionStyles;

const CENCategoryNameAndAdditionalDescription = ({ category, currentPage }: Props) => {
    if (!category) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.categoryName}>{category.name}</Typography>
            {category.properties.categoryAdditionalDescription && (
                <Typography {...styles.categoryAdditionalDescription}>
                    {category.properties.categoryAdditionalDescription}
                </Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CENCategoryNameAndAdditionalDescription)),
    definition: {
        group: "Categories",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
